import React from 'react';
import PropTypes from 'prop-types';

import styles from '../styles/formFieldLabel.module.scss';

const FormFieldLabel = ({
  fieldId,
  label,
  LabelAddOn = null,
  isRequired = false,
  isInputLabel = false,
}) => {
  if (!label) return null;

  const LabelElement = isInputLabel ? 'label' : 'div';

  return (
    <LabelElement
      className={styles.element}
      htmlFor={isInputLabel ? fieldId : undefined}
      id={`${fieldId}-label`}
    >
      {label}
      {isRequired && <span className={styles.requiredAsterisk}>&#42;</span>}
      {LabelAddOn && <LabelAddOn />}
    </LabelElement>
  );
};

FormFieldLabel.propTypes = {
  fieldId: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  label: PropTypes.string.isRequired,
  LabelAddOn: PropTypes.elementType,
  isInputLabel: PropTypes.bool,
};

export { FormFieldLabel as FormFieldLabelStorybook };
export default React.memo(FormFieldLabel);
